// extracted by mini-css-extract-plugin
module.exports = {"LanguageSelector":"LanguageSelector__2S5BO","LanguageSelector_link":"LanguageSelector_link__2S5BO","LanguageSelector_link___active":"LanguageSelector_link___active__2S5BO"};